export default __webpack_public_path__ + "static/media/investment.94e2bec7.svg";